export const GET_SEARCH_ALP = 'GET_SEARCH_ALP';
export const GET_UO_ALP = 'GET_UO_ALP';

export function getSearchALP(path = '', query, subrequest) {
  return {
    type: GET_SEARCH_ALP,
    subrequest,
    request: {
      op: 'get',
      path: `${path}/@attivita-libero-professionale-search?${new URLSearchParams(
        query,
      )}`,
    },
  };
}

export function getUOALP() {
  return {
    type: GET_UO_ALP,
    request: {
      op: 'get',
      path: `/@unita-organizzative-alp`,
    },
  };
}
